import axios from 'axios';

// ACTION TYPES
const name = 'data';
export const actionTypes = {
  LOAD_DATA: `${name}:load_data`,
  FILTER_DATA: `${name}:filter_data`,
  SET_SORT: `${name}:set_sort`,
  SORT_DATA: `${name}:sort_data`,
  SORT_DATA_DETAILS: `${name}:`,
  SET_PRODUCTTYPE: `${name}:set_producttype`,
  SET_MGTSTYLE: `${name}:set_mgtstyle`,
  SET_TIER1CAT: `${name}:set_tier1cat`,
  SET_TIER2CAT: `${name}:set_tier2cat`,
  SET_TIER3CAT: `${name}:set_tier3cat`,
  SET_COUNTRYEXP: `${name}:set_countryexp`,
  SET_PRODUCT_REGION: `${name}:set_productregion`,
  SET_USEOFINCOME: `${name}:set_useofincome`,
  SET_ESG: `${name}:set_esg`,
  SET_CURRENCIES: `${name}:set_currencies`,
  SET_LEVERAGEDOPT: `${name}:set_leveragedopt`,
  SET_AUM: `${name}:set_aum`,
  SET_MSTAR: `${name}:set_mstar`,
  SET_YIELD: `${name}:set_yield`,
  SET_INCEPTION: `${name}:set_inception`,
  SET_EXPENSE: `${name}:set_expense`,
  SET_VOLUME: `${name}:set_volume`,
  SET_SHOWLIST: `${name}:set_showdoc`,
  SET_SHOWFLAG: `${name}:set_showflag`,
  SET_FILTER_WORD: `${name}:set_filterword`,
  CLEAR_FILTERS: `${name}:clear_filters`,
  LOAD_FUND_DATA_EXCEL: `${name}:'load_fund_data_excel`,
  SET_ACTIVE_PANE: 'set_active_pane',
  RESET_LOAD_STATUS: 'set_loadstatus',
};

const defaultOption = [];

function getParamValue(param) {
  const vars = {};
  window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
    vars[key] = decodeURIComponent(value);
  });
  const val = vars[param];
  if (val == null) {
    return null;
  } else {
    const values = val.split(',').map(i => {
      return { value: i };
    });
    return values;
  }
}

// ACTIONS
export function loadData() {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.RESET_LOAD_STATUS, value: false });
    const request = {
      method: 'GET',
      url: `${process.env.REACT_APP_API_URL}/data`,
      params: {
        divisionId: getState().params.division,
        wtRegion: getState().params.wtRegion,
        isoCode: getState().params.isoCode,
        isLeveraged: getState().params.isLeveraged,
        isFP: getState().params.isFP,
      },
    };
    return axios(request)
      .then(response => {
        console.log('RESPONSE', response);
        dispatch({ type: actionTypes.LOAD_DATA, value: response.data });
        dispatch({ type: actionTypes.RESET_LOAD_STATUS, value: true });
        // filters from window params
        if (window.fundListingsParams) {
          // structure (mgtStyle)
          if (window.fundListingsParams.structure) {
            const values = window.fundListingsParams.structure.split(',').map(i => {
              return { value: i };
            });
            dispatch(setMgtStyle(values));
          }
          // productType
          if (window.fundListingsParams.productType) {
            const values = window.fundListingsParams.productType.split(',').map(i => {
              return { value: i };
            });
            dispatch(setProductType(values));
          }
          // assetClass
          if (window.fundListingsParams.assetClass) {
            const values = window.fundListingsParams.assetClass.split(',').map(i => {
              return { value: i };
            });
            dispatch(setTier1Cat(values));
          }
          // subAssetClass
          if (window.fundListingsParams.subAssetClass) {
            const values = window.fundListingsParams.subAssetClass.split(',').map(i => {
              return { value: i };
            });
            dispatch(setTier2Cat(values));
          }
          // industrySubGroup
          if (window.fundListingsParams.industrySubGroup) {
            const values = window.fundListingsParams.industrySubGroup.split(',').map(i => {
              return { value: i };
            });
            dispatch(setTier3Cat(values));
          }
          // productRegion
          if (window.fundListingsParams.productRegion) {
            const values = window.fundListingsParams.productRegion.split(',').map(i => {
              return { value: i };
            });
            dispatch(setProductRegion(values));
          }
          // responsible investing
          if (window.fundListingsParams.esg) {
            const values = window.fundListingsParams.esg.split(',').map(i => {
              return { value: i };
            });
            dispatch(setEsg(values));
          }
        }

        // filter from URL query string
        // structure (mgtStyle)
        if (!window.fundListingsParams.structure) {
          const structure = getParamValue('structure');
          if (structure != null) {
            dispatch(setMgtStyle(structure));
          }
        }
        // productType
        if (!window.fundListingsParams.productType) {
          const searchProductType = getParamValue('productType');
          if (searchProductType != null) {
            dispatch(setProductType(searchProductType));
          }
        }
        // assetClass
        if (!window.fundListingsParams.assetClass) {
          const searchAssetClass = getParamValue('assetClass');
          if (searchAssetClass != null) {
            dispatch(setTier1Cat(searchAssetClass));
          }
        }
        // subAssetClass
        if (!window.fundListingsParams.subAssetClass) {
          const searchSubAssetClass = getParamValue('subAssetClass');
          if (searchSubAssetClass != null) {
            dispatch(setTier2Cat(searchSubAssetClass));
          }
        }
        // industrySubGroup
        if (!window.fundListingsParams.industrySubGroup) {
          const industrySubGroup = getParamValue('industrySubGroup');
          if (industrySubGroup != null) {
            dispatch(setTier3Cat(industrySubGroup));
          }
        }
        // productRegion
        if (!window.fundListingsParams.productRegion) {
          const searchProductRegion = getParamValue('productRegion');
          if (searchProductRegion != null) {
            dispatch(setProductRegion(searchProductRegion));
          }
        }
        // ESG
        if (!window.fundListingsParams.esg) {
          const searchEsg = getParamValue('esg');
          if (searchEsg != null) {
            dispatch(setEsg(searchEsg));
          }
        }
      })
      .catch(error => {
        console.error(error);
        dispatch({ type: actionTypes.RESET_LOAD_STATUS, value: true });
      });
  };
}

export function setSort(column) {
  return dispatch => {
    dispatch({ type: actionTypes.SET_SORT, column: column });
    dispatch({ type: actionTypes.SORT_DATA, column: column });
  };
}

export function setSortDetails(column, datatype) {
  return dispatch => {
    dispatch({ type: actionTypes.SET_SORT, column: column });
    dispatch({ type: actionTypes.SORT_DATA_DETAILS, payload: { column: column, datatype: datatype } });
  };
}

export function setProductType(types) {
  return dispatch => {
    dispatch({ type: actionTypes.SET_FILTER_WORD, value: '' });
    const selected = types.map(i => i.value);
    dispatch({ type: actionTypes.SET_PRODUCTTYPE, value: selected });
    dispatch({ type: actionTypes.FILTER_DATA });
  };
}

export function setMgtStyle(styles) {
  return dispatch => {
    dispatch({ type: actionTypes.SET_FILTER_WORD, value: '' });
    const selected = styles.map(i => i.value);
    dispatch({ type: actionTypes.SET_MGTSTYLE, value: selected });
    dispatch({ type: actionTypes.FILTER_DATA });
  };
}

export function setTier1Cat(tier1) {
  return dispatch => {
    dispatch({ type: actionTypes.SET_FILTER_WORD, value: '' });
    const selected = tier1.map(i => i.value);
    dispatch({ type: actionTypes.SET_TIER1CAT, value: selected });
    dispatch({ type: actionTypes.FILTER_DATA });
  };
}

export function setTier2Cat(tier2) {
  return dispatch => {
    dispatch({ type: actionTypes.SET_FILTER_WORD, value: '' });
    const selected = tier2.map(i => i.value);
    dispatch({ type: actionTypes.SET_TIER2CAT, value: selected });
    dispatch({ type: actionTypes.FILTER_DATA });
  };
}

export function setTier3Cat(tier3) {
  return dispatch => {
    dispatch({ type: actionTypes.SET_FILTER_WORD, value: '' });
    const selected = tier3.map(i => i.value);
    dispatch({ type: actionTypes.SET_TIER3CAT, value: selected });
    dispatch({ type: actionTypes.FILTER_DATA });
  };
}

export function setCountryExp(country) {
  return dispatch => {
    dispatch({ type: actionTypes.SET_FILTER_WORD, value: '' });
    const selected = country.map(i => i.value);
    dispatch({ type: actionTypes.SET_COUNTRYEXP, value: selected });
    dispatch({ type: actionTypes.FILTER_DATA });
  };
}

export function setProductRegion(productRegion) {
  return dispatch => {
    dispatch({ type: actionTypes.SET_FILTER_WORD, value: '' });
    const selected = productRegion.map(i => i.value);
    dispatch({ type: actionTypes.SET_PRODUCT_REGION, value: selected });
    dispatch({ type: actionTypes.FILTER_DATA });
  };
}

export function setLeveraged(leverage) {
  return dispatch => {
    dispatch({ type: actionTypes.SET_FILTER_WORD, value: '' });
    const selected = leverage.map(i => i.value);
    dispatch({ type: actionTypes.SET_LEVERAGEDOPT, value: selected });
    dispatch({ type: actionTypes.FILTER_DATA });
  };
}

export function clearFilters() {
  return dispatch => {
    dispatch({ type: actionTypes.SET_MGTSTYLE, value: defaultOption });
    dispatch({ type: actionTypes.SET_TIER1CAT, value: defaultOption });
    dispatch({ type: actionTypes.SET_TIER2CAT, value: defaultOption });
    dispatch({ type: actionTypes.SET_COUNTRYEXP, value: defaultOption });
    dispatch({ type: actionTypes.SET_PRODUCT_REGION, value: defaultOption });
    dispatch({ type: actionTypes.SET_LEVERAGEDOPT, value: defaultOption });
    dispatch({ type: actionTypes.SET_ESG, value: defaultOption });
    dispatch({ type: actionTypes.SET_MSTAR, value: defaultOption });
    dispatch({ type: actionTypes.SET_AUM, value: defaultOption });
    dispatch({ type: actionTypes.SET_INCEPTION, value: defaultOption });
    dispatch({ type: actionTypes.SET_VOLUME, value: defaultOption });
    dispatch({ type: actionTypes.SET_EXPENSE, value: defaultOption });
    dispatch({ type: actionTypes.SET_YIELD, value: defaultOption });
  };
}

export function setUseOfIncome(useOfIncome) {
  return dispatch => {
    dispatch({ type: actionTypes.SET_FILTER_WORD, value: '' });
    const selected = useOfIncome.map(i => i.value);
    dispatch({ type: actionTypes.SET_USEOFINCOME, value: selected });
    dispatch({ type: actionTypes.FILTER_DATA });
  };
}

export function setEsg(esg) {
  return dispatch => {
    dispatch({ type: actionTypes.SET_FILTER_WORD, value: '' });
    const selected = esg.map(i => i.value);
    dispatch({ type: actionTypes.SET_ESG, value: selected });
    dispatch({ type: actionTypes.FILTER_DATA });
  };
}

export function setMstar(mstar) {
  return dispatch => {
    dispatch({ type: actionTypes.SET_FILTER_WORD, value: '' });
    //const selected = mstar.map(i => i.value);
    const selected = mstar.value;
    dispatch({ type: actionTypes.SET_MSTAR, value: selected });
    dispatch({ type: actionTypes.FILTER_DATA });
  };
}

export function setAum(aum) {
  return dispatch => {
    dispatch({ type: actionTypes.SET_FILTER_WORD, value: '' });
    //const selected = aum.map(i => i.value);
    const selected = aum.value;
    dispatch({ type: actionTypes.SET_AUM, value: selected });
    dispatch({ type: actionTypes.FILTER_DATA });
  };
}

export function setInception(inception) {
  return dispatch => {
    dispatch({ type: actionTypes.SET_FILTER_WORD, value: '' });
    const selected = inception.value;
    dispatch({ type: actionTypes.SET_INCEPTION, value: selected });
    dispatch({ type: actionTypes.FILTER_DATA });
  };
}

export function setYield(ttmyield) {
  return dispatch => {
    dispatch({ type: actionTypes.SET_FILTER_WORD, value: '' });
    const selected = ttmyield.value;
    dispatch({ type: actionTypes.SET_YIELD, value: selected });
    dispatch({ type: actionTypes.FILTER_DATA });
  };
}

export function setVolume(volume) {
  return dispatch => {
    dispatch({ type: actionTypes.SET_FILTER_WORD, value: '' });
    const selected = volume.value;
    dispatch({ type: actionTypes.SET_VOLUME, value: selected });
    dispatch({ type: actionTypes.FILTER_DATA });
  };
}

export function setExpense(expense) {
  return dispatch => {
    dispatch({ type: actionTypes.SET_FILTER_WORD, value: '' });
    const selected = expense.value;
    dispatch({ type: actionTypes.SET_EXPENSE, value: selected });
    dispatch({ type: actionTypes.FILTER_DATA });
  };
}

export function setShowDocumentForm() {
  return dispatch => {
    dispatch({ type: actionTypes.SET_SHOWLIST });
  };
}

export function toggleDocumentForm(ticker) {
  return dispatch => {
    dispatch({ type: actionTypes.SET_SHOWLIST, ticker: ticker });
    dispatch({ type: actionTypes.SET_SHOWFLAG, ticker: ticker });
  };
}

export function setFilterWord(filterWord) {
  return dispatch => {
    dispatch(clearFilters());
    dispatch({ type: actionTypes.SET_FILTER_WORD, value: filterWord });
  };
}

export function getExcel() {
  return dispatch => {
    dispatch(loadFundDataExcel());
  };
}

export function loadFundDataExcel() {
  return (dispatch, getState) => {
    const request = {
      method: 'GET',
      responseType: 'blob',
      url: `${process.env.REACT_APP_API_URL}/excel`,
      params: {
        divisionId: getState().params.division,
        wtRegion: getState().params.wtRegion,
        isoCode: getState().params.isoCode,
        isLeveraged: getState().params.isLeveraged,
        isFP: getState().params.isFP,
      },
    };
    return axios(request)
      .then(response => {
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const a = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = 'WisdomTree-ETF.xlsx';
        a.click();
      })
      .catch(error => {
        console.log(error);
      });
  };
}

/* sets which page to show */
export function setActivePane(param) {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.SET_ACTIVE_PANE, value: param });
  };
}



// WEBPACK FOOTER //
// ./src/actions/data.js